module.exports = __webpack_public_path__ + "img/ru.f461b502.png";